import { render, staticRenderFns } from "./SingleSelectionList.vue?vue&type=template&id=41106084"
import script from "./SingleSelectionList.vue?vue&type=script&lang=js"
export * from "./SingleSelectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports